import Clarity from '@microsoft/clarity';

export class ClarityService {
  private static isInitialized = false;

  static init(projectId: string) {
    try {
      if (typeof window !== 'undefined' && projectId && !this.isInitialized) {
        Clarity.init(projectId);
        this.isInitialized = true;
      }
    } catch (error) {
      console.warn('Clarity initialization failed:', error);
    }
  }

  static identify(customId: string, sessionId?: string, pageId?: string, friendlyName?: string) {
    try {
      if (this.isInitialized) {
        Clarity.identify(customId, sessionId, pageId, friendlyName);
      }
    } catch (error) {
      console.warn('Clarity identify failed:', error);
    }
  }

  static setTag(key: string, value: string) {
    try {
      if (this.isInitialized && key && value) {
        Clarity.setTag(key, value);
      }
    } catch (error) {
      console.warn('Clarity setTag failed:', error);
    }
  }

  static event(name: string) {
    try {
      if (this.isInitialized && name) {
        Clarity.event(name);
      }
    } catch (error) {
      console.warn('Clarity event failed:', error);
    }
  }

  static consent() {
    try {
      if (this.isInitialized) {
        Clarity.consent();
      }
    } catch (error) {
      console.warn('Clarity consent failed:', error);
    }
  }

  static upgrade(upgradeReason: string) {
    try {
      if (this.isInitialized && upgradeReason) {
        Clarity.upgrade(upgradeReason);
      }
    } catch (error) {
      console.warn('Clarity upgrade failed:', error);
    }
  }
}